import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 0,
    lpSymbol: 'NEWO',
    lpAddresses: {
      97: '',
      56: '0x8878A13F19fA7F61AE0BB63F4Ab5ce5D519F67D0',
    },
    tokenSymbol: 'SYRUP',
    tokenAddresses: {
      97: '',
      56: '0x8878A13F19fA7F61AE0BB63F4Ab5ce5D519F67D0',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },

  {
    pid: 1,
    lpSymbol: 'NEWO-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x04228C33A8409a7510f4A9E81d38D31793Eec06D',   // lp address token-bnb
    },
    tokenSymbol: 'NEWO',
    tokenAddresses: {
      97: '',
      56: '0x8878A13F19fA7F61AE0BB63F4Ab5ce5D519F67D0', // token address
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },

]

export default farms
